import React from 'react';
import styled from 'styled-components';

const CTASection = styled.section`
  padding: 7.2rem 5%;
  background: ${props => props.theme.colors.accentGradient};
  text-align: center;
  position: relative;
  overflow: hidden;
  
  &::before, &::after {
    content: '';
    position: absolute;
    width: 270px;
    height: 270px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.1);
  }
  
  &::before {
    top: -135px;
    left: -135px;
  }
  
  &::after {
    bottom: -135px;
    right: -135px;
  }
`;

const CTAContent = styled.div`
  max-width: 720px;
  margin: 0 auto;
  position: relative;
  z-index: 1;
`;

const CTATitle = styled.h2`
  font-size: 2.7rem;
  margin-bottom: 1.35rem;
  color: white;
  
  @media (max-width: 768px) {
    font-size: 2.25rem;
  }
`;

const CTASubtitle = styled.p`
  font-size: 1.08rem;
  margin-bottom: 2.7rem;
  color: rgba(255, 255, 255, 0.9); /* Amélioré pour un meilleur contraste */
  line-height: 1.6;
  max-width: 630px;
  margin-left: auto;
  margin-right: auto;
`;

const CTAButton = styled.a`
  background: white;
  color: #5E17EB;
  padding: 0.9rem 2.25rem;
  border-radius: 45px;
  font-weight: 600;
  font-size: 0.99rem;
  transition: all 0.3s ease;
  display: inline-block;
  text-decoration: none;
  box-shadow: 0 3.6px 7.2px rgba(0, 0, 0, 0.1);
  
  &:hover {
    transform: translateY(-4.5px);
    box-shadow: 0 13.5px 27px rgba(0, 0, 0, 0.2);
  }
  
  &:focus {
    outline: 2.7px solid white;
    outline-offset: 2.7px;
    transform: translateY(-2.7px);
  }
  
  /* Accessibilité pour la navigation au clavier */
  &:focus:not(:focus-visible) {
    outline: none;
  }
  
  &:focus-visible {
    outline: 2.7px solid white;
    outline-offset: 2.7px;
  }
  
  /* Effets au clic */
  &:active {
    transform: translateY(-1.8px);
    box-shadow: 0 9px 18px rgba(0, 0, 0, 0.15);
  }
`;

// Ajout d'un composant pour les lecteurs d'écran
const ScreenReaderText = styled.span`
  position: absolute;
  width: 0.9px;
  height: 0.9px;
  padding: 0;
  margin: -0.9px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
`;

const CTA = () => {
  return (
    <CTASection id="cta" aria-labelledby="cta-title">
      <CTAContent>
        <CTATitle id="cta-title">Prêt à créer votre site web professionnel ?</CTATitle>
        <CTASubtitle>
          Contactez-nous dès aujourd'hui pour discuter de votre projet et obtenir un devis personnalisé, sans engagement.
        </CTASubtitle>
        <CTAButton
          href="#contact"
          aria-label="Commencer maintenant et nous contacter pour votre projet de site web"
          onClick={() => {
            // Optionnel : Ajout de suivi d'événement pour le SEO
            if (window.gtag) {
              window.gtag('event', 'click', {
                'event_category': 'Conversion',
                'event_label': 'CTA Button',
                'value': 1
              });
            }
          }}
        >
          Commencer maintenant
          <ScreenReaderText> pour nous contacter à propos de votre site web</ScreenReaderText>
        </CTAButton>
      </CTAContent>
    </CTASection>
  );
};

export default CTA;